import { customFetch } from "@/client/custom-fetch";

import { TPlatform, TPlatformResponse } from "./platform.types";

export const getPlatforms = async (
  organizationId: string,
  projectId?: string
): Promise<TPlatformResponse> => {
  // A API só permite buscar plataformas por projeto ou por ID
  // Se não tiver projectId, retornar array vazio
  if (!projectId) {
    return [];
  }
  
  return customFetch<TPlatformResponse>(`/platforms/project/${projectId}`, {
    method: "GET",
    headers: {
      accept: "application/json",
    },
  });
};

export const createPlatform = async (
  organizationId: string,
  formData: FormData
): Promise<TPlatform> => {
  return customFetch<TPlatform>(`/platforms/organization/${organizationId}`, {
    method: "POST",
    body: formData,
    skipLoading: false,
  });
};

export const getPlatformById = async (
  organizationId: string,
  platformId: string
): Promise<TPlatform> => {

  return customFetch<TPlatform>(
    `/platforms/${platformId}`,
    {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    }
  );
};

export const updatePlatform = async (
  organizationId: string,
  platformId: string,
  formData: FormData
): Promise<TPlatform> => {
  return customFetch<TPlatform>(
    `/platforms/${platformId}`,
    {
      method: "PATCH",
      body: formData,
      skipLoading: false,
    }
  );
};

export const deletePlatform = async (
  organizationId: string,
  platformId: string,
  body?: { confirm?: boolean; reason?: string }
): Promise<{ message: string }> => {
  return customFetch<{ message: string }>(
    `/platforms/${platformId}`,
    {
      method: "DELETE",
      headers: {
        accept: "application/json",
        "x-organization-id": organizationId,
      },
      body: body ? JSON.stringify(body) : undefined,
    }
  );
};
